module.exports = __webpack_public_path__ + "img/chuvak-overlay.72694804.png";